import { landingCar } from '../images'
import React, { FC } from 'react'

const LandingAboutImage: FC<{ alt: string; className: string }> = ({ className, alt }) => (
  <img src={landingCar} alt={alt} className={className} />
)

export default LandingAboutImage
